import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import AddBankPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/AddBankPage";

function AddBank() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  const handleNewBank = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleAddCompanyBankAccount(data);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        return true;
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
        return false;
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
      return false;
    }
  };

  return <AddBankPage handleNewBank={handleNewBank} loading={loading} />;
}

export default AddBank;
